import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarMenu,
  SidebarGroup,
} from '@predoc/cow';
import { Settings } from 'lucide-react';
import { NavUser } from '@/feature/layout/NavUser';
import { lowerNavItems, upperNavItems } from '@/feature/layout/constants';
import { Permission, useHasPermission } from '@/utils/roles';
import { useGetOrganizationInfo } from '@/feature/profiles/hooks/organizationAPI';

import { DownloadsNavItem } from '@/feature/downloads/DownloadsSheet';
import { AppSidebarHeader } from './AppSidebarHeader';
import { SidebarNavItem } from './SidebarNavitem';
import { useAuth } from '@/routes/AuthContext';

const OrganizationSettingsNavItem = ({ enabled }: { enabled: boolean }) => {
  const { hasPermission } = useHasPermission(
    Permission.VIEW_ORGANIZATION_SETTINGS,
    true,
    { enabled },
  );
  const { data: organizationInfo } = useGetOrganizationInfo({
    enabled: enabled && hasPermission,
  });

  if (!hasPermission || !organizationInfo?.enableDataDeletionRequests) {
    return null;
  }

  return (
    <SidebarNavItem
      title="Organization Settings"
      url="/organization-settings"
      icon={Settings}
    />
  );
};

export const AppSidebar = () => {
  const { isAuthenticated, isLoading } = useAuth();
  const authReady = isAuthenticated && !isLoading;

  return (
    <Sidebar collapsible="icon">
      <AppSidebarHeader />
      <SidebarContent>
        <SidebarGroup>
          <SidebarMenu>
            {upperNavItems.map((item) => (
              <SidebarNavItem
                key={item.title}
                {...item}
                permissionsEnabled={authReady}
              />
            ))}
            <DownloadsNavItem enabled={authReady} />
          </SidebarMenu>
        </SidebarGroup>
        <SidebarGroup className="mt-auto">
          <SidebarMenu>
            {lowerNavItems.map((item) => (
              <SidebarNavItem
                key={item.title}
                {...item}
                permissionsEnabled={authReady}
              />
            ))}
            <OrganizationSettingsNavItem enabled={authReady} />
          </SidebarMenu>
        </SidebarGroup>
      </SidebarContent>
      <SidebarFooter>{<NavUser enabled={authReady} />}</SidebarFooter>
    </Sidebar>
  );
};
